// extracted by mini-css-extract-plugin
export var googleSigninButton = "sign-in-with-google-module--googleSigninButton--140ZN";